import AssociateTaskModal from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/AssociateTaskModal.js';
import ReplyContainer from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/ReplyRequestorModal';
import AddWorklogModal from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/AddWorklogModal';
import AddNoteActionModal from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/AddNoteActionModal';
import UpdatePropertyActionModal from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/UpdatePropertyActionModal';
import AddStepNoteAction from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/AddStepNoteAction';
import SideConversationActionModal from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/SideConversationActionModal';
import KnowledgeBaseAction from '@nile/banyan/src/Containers/PageContainers/Runbooks/ActionListModals/KnowledgeBaseAction';

const getRunbooksDataProperties = (enumType, isAutoAction = false) => {
  let actionType = {
    icon: '',
    name: '',
    i18n: ''
  };

  switch (enumType) {
    case 'CHECKLIST':
      actionType = {
        icon: 'TickColoured',
        name: 'Add Step',
        i18n: 'admin.runbooks.templateactions.addstep'
      };
      break;
    case 'TASK_TEMPLATE':
      actionType = {
        icon: 'TaskColoured',
        name: 'Associate Task',
        component: AssociateTaskModal,
        i18n: 'admin.runbooks.templateactions.associatetask'
      };
      break;
    case 'RUN_SCRIPT':
    case 'SCRIPT':
      actionType = {
        icon: 'ScriptColoured',
        name: 'Run Script',
        i18n: 'asset.runscript.title'
      };
      break;
    case 'NON_MONITORING_ASSET':
      actionType = {
        icon: 'ITDocumentColoured',
        name: 'Refer IT Documentation',
        i18n: 'admin.runbooks.templateactions.referitdoc'
      };
      break;
    case 'KNOWLEDGE_BASE':
      actionType = {
        icon: 'KBArticle',
        name: 'Knowledge Base',
        component: KnowledgeBaseAction,
        i18n: 'admin.runbooks.templateactions.referKnowledgebase'
      };
      break;
    case 'TICKET_REPLY':
    case 'REPLY_REQUESTOR':
      actionType = {
        icon: 'ReplyColoured',
        name: 'Reply Requestor',
        component: ReplyContainer,
        i18n: 'admin.runbooks.templateactions.replyrequestor'
      };
      break;
    case 'SIDE_CONVERSATION':
      actionType = {
        icon: 'SideConversationColoured',
        name: 'Side Conversation',
        component: SideConversationActionModal,
        i18n: 'admin.runbooks.templateactions.sideconversation'
      };
      break;
    case 'TICKET_APPROVAL':
    case 'INITIATE_APPROVAL':
      actionType = {
        icon: 'ThumbsUpColoured',
        name: 'Initiate Approval',
        i18n: 'ticket.details.insights.initiateApprovals'
      };
      break;
    case 'TICKET_UPDATE':
    case 'UPDATE_PROPERTY':
      actionType = {
        icon: 'ReloadColoured',
        name: 'Update Property',
        component: UpdatePropertyActionModal,
        i18n: 'admin.runbooks.templateactions.updateproperty'
      };
      break;
    case 'REQUEST_NOTE':
    case 'NOTE':
      actionType = {
        icon: 'NotesColoured',
        name: 'Request Note',
        component: isAutoAction ? AddNoteActionModal : AddStepNoteAction,
        i18n: isAutoAction
          ? 'admin.runbooks.templateactions.addnote'
          : 'admin.runbooks.templateactions.requestnote'
      };
      break;
    case 'ADD_WORKLOG':
    case 'WORKLOG':
      actionType = {
        icon: 'WorklogColoured',
        name: 'Add Worklog',
        component: AddWorklogModal,
        i18n: 'admin.runbooks.templateactions.addworklog'
      };
      break;
    case 'GROUP':
      actionType = {
        icon: 'AutoAction',
        name: 'Auto Action',
        i18n: 'admin.runbooks.templateactions.autoaction'
      };
      break;

    default:
      break;
  }
  return actionType;
};

export { getRunbooksDataProperties };
